import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Dropdown } from 'react-bootstrap';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';
import { BiLabel } from 'react-icons/bi';
import { connect } from 'react-redux';
import { getTeamVisitLabel } from '@/_helpers';

const StyledDropdown = styled(Dropdown)`
    button {
        background: transparent;
        border: none;
        :hover {
            background: transparent;
        }
        &.show > .btn-success.dropdown-toggle {
            background-color: transparent;
        }
    }
`;

const Component = React.memo(({ handleLabelChange, labels = {}, defaultLabels = {}, teamId, teamDetails }) => {
    return (
        <StyledDropdown>
            <Dropdown.Toggle
                variant="link"
                id="dropdown-basic"
                css={css`
                    margin: 0 !important;
                    padding: 0 !important;
                `}
            >
                <BiLabel className="icon edit" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {Object.keys(labels).map((labelKey) => (
                    <Dropdown.Item key={labelKey} onClick={() => handleLabelChange(labelKey)}>
                        <span
                            css={css`
                                color: ${labels?.[labelKey] || '#444'};
                                ${labels?.[labelKey] === '#ffffffff' ? 'background-color: #e5e7eb' : ''}
                            `}
                        >
                            {getTeamVisitLabel(labelKey, teamDetails) || labelKey}
                        </span>
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </StyledDropdown>
    );
});

const ChangeVisitLabel = (props) => (
    <ComponentErrorBoundary componentErrorMessage={'Error Displaying ChangeVisitLabel'}>
        <Component {...props} />
    </ComponentErrorBoundary>
);

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(ChangeVisitLabel);
